import React, { useContext } from 'react'

import { RootContext } from '../../context/rootContext'
import { LoadingMask, Container } from './styles'

const Spinner = () => {
  const { loadingState } = useContext(RootContext)
  const [loading] = loadingState
  return (
    <LoadingMask loading={loading ? 1 : 0}>
      <Container />
    </LoadingMask>
  )
}

export default Spinner
